import React, { useEffect, useState } from "react";
import { Layout, Button, Card, Row, Col } from "antd";
import CommisionOrders from "./CommisionOrder";
import Completed from "./AdminCompletedOrder";
import Return from "./AdminReturnOrders";
import Cancel from "./AdminCancelOrder";
import AdminPackedOrder from "./AdminPackedOrder";
import AdminEcomShipment from "./AdminEcomShipmentOrders";
import ReturnOrders from "./ReturnOrders";
import "./Styles/staffManagement.css"; // Assuming you have a CSS file for styling

const { Content } = Layout;

const OrdersManagement = () => {
  const [activeTab, setActiveTab] = useState("commission");
  const [role, setRole] = useState(null);

  useEffect(() => {
    const Role = localStorage.getItem("role");
    console.log(Role);
    setRole(Role);
  }, []);

  return (
    <Layout className="admin-dashboard-layout">
      {/* <Content className="admin-dashboard-content"> */}
      <Card title="Commission Management" className="admin-dashboard-card">
        <Row gutter={[16, 16]} justify="space-between">
          <Col xs={24} sm={6} style={{ paddingBottom: 20 }}>
            <Button
              type={activeTab === "commission" ? "primary" : "default"}
              onClick={() => setActiveTab("commission")}
              block
            >
              Commission Orders
            </Button>
          </Col>
        </Row>
        {activeTab === "commission" &&
          (role === "admin" ? <CommisionOrders /> : <CommisionOrders />)}
        {activeTab === "completed" &&
          (role === "admin" ? <Completed /> : <Completed />)}
        {activeTab === "return" && (role === "admin" ? <Return /> : <Return />)}
        {activeTab === "cancel" && (role === "admin" ? <Cancel /> : <Cancel />)}
      </Card>
      {/* </Content> */}
    </Layout>
  );
};

export default OrdersManagement;
